import type { PageLoad } from './$types';
import { loadPublishedMeetingMinutes, groupMeetingsByYear } from '$lib/utils/meetingLoader';

export const load: PageLoad = async () => {
	// Load all published meetings using Zod-validated loader
	const publishedMeetings = await loadPublishedMeetingMinutes();

	// Recent minutes are already sorted by the loader (newest first)
	const recentMinutes = publishedMeetings;

	// Group by year for yearly navigation
	const yearlyMinutes = groupMeetingsByYear(publishedMeetings);

	return {
		recentMinutes,
		yearlyMinutes
	};
};
